import Home from "./dienlanhsaigon/Home/Home";
import logo from "./logo.svg";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homerut from "./Rut/Homerut";
import Maylanh from "./dienlanhsaigon//Maylanh/Maylanh";
import Tulanh from "./dienlanhsaigon/Tulanh/Tulanh";
import Maygiat from "./dienlanhsaigon/Maygiat/Maygiat";
import Tivi from "./dienlanhsaigon/Tivi/Tivi";
import Tuyendung from "./Tuyen-dung/Tuyendung";
import Giadung from "./Giadung/Giadung";
import Gdprivacy from "./Giadung/Gdprivacy";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<Homerut />} />
          <Route path="/nhanuudai" element={<Homerut />} />
          <Route path="/baophi" element={<Homerut />} />
          <Route path="/so1" element={<Homerut />} />
          <Route path="/rutonline" element={<Homerut />} />
          <Route path="/rutnhanh" element={<Homerut />} />
          <Route path="/quytrinhrut" element={<Homerut />} />
          <Route path="/dien-lanh" element={<Home />} />
          <Route path="/maylanh" element={<Maylanh />} />
          <Route path="/tulanh" element={<Tulanh />} />
          <Route path="/maygiat" element={<Maygiat />} />
          <Route path="/tivi" element={<Tivi />} />
          <Route path="/tuyendung" element={<Tuyendung />} />
          <Route path="/giadung" element={<Giadung />} />
          <Route path="/privacy" element={<Gdprivacy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
